import React from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../ui/Card';
import { MousePointer2 } from "lucide-react";
import {
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    LineChart,
    Line
} from "recharts";
const BounceRateTrend = ({ bounceRateData }) => {
    const transformed = bounceRateData && bounceRateData.map((item, index) => ({
        name: `${item.name}`,
        rate: item.bounceRate
    }));
    return (
        <Card className="shadow-elegant">
            <CardHeader>
                <CardTitle className="flex items-center gap-2">
                    <MousePointer2 className="h-5 w-5 text-primary" />
                    Çıkma Oranı Trendi
                </CardTitle>
                <CardDescription>Haftalık çıkma oranı analizi</CardDescription>
            </CardHeader>
            <CardContent >
                <ResponsiveContainer width="100%" height={200}>
                    <LineChart data={transformed}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                        <XAxis dataKey="name" stroke="#888" />
                        <YAxis stroke="#888" />
                        <Tooltip
                            contentStyle={{
                                backgroundColor: 'white',
                                border: 'none',
                                borderRadius: '8px',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                            }}
                            formatter={(value) => [`${value}%`, 'Çıkma Oranı']}
                        />
                        <Line
                            type="monotone"
                            dataKey="rate"
                            stroke="#A855F7"
                            strokeWidth={3}
                            dot={{ fill: '#A855F7', strokeWidth: 2, r: 6 }}
                        />
                    </LineChart>
                </ResponsiveContainer>
            </CardContent>
        </Card>
    )
}

export default BounceRateTrend